export default {
  //用户列表
  setSolution: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/solution/list.vue'));
    }, '/modules/solution/list');
  }
  // //应用客户
  // solutionCustomers: resolve => {
  //   require.ensure([], () => {
  //     resolve(require('@/views/solution/customers-list.vue'));
  //   }, '/modules/solution/customers-list');
  // },
  // //物料
  // solutionMaterial: resolve => {
  //   require.ensure([], () => {
  //     resolve(require('@/views/solution/material-list.vue'));
  //   }, '/modules/solution/material-list');
  // },
  //jcn与行业
  // solutionIndustry: resolve => {
  //   require.ensure([], () => {
  //     resolve(require('@/views/solution-ft/jcn-industry-list.vue'));
  //   }, '/modules/solution-ft/jcn-industry-list');
  // }
}



// WEBPACK FOOTER //
// ./src/router/modules/solution.js